/*
 * Google automated discount price in the theme's own sale style.
 *
 * Simprosys (Google Shopping Feed app) reads the pv2 token Google adds to Shopping ad clicks and
 * replaces the product price with its own markup: `.gsf-spd-price` holding a red sale price and a
 * struck-through regular price, both as "2.727,00 kr" with inline styles. This script takes those two
 * numbers and renders them the way a compare-at sale looks in this theme (template-product.liquid):
 * `.price` + `.info > .old, .save "N% rabatt"`. Simprosys keeps control of the discount itself (the
 * GSF-SPD code it puts in the cart); only the display changes. Its block is hidden, not removed, so it
 * can still update the numbers when the variant changes.
 */
(function () {
  var label = window.kgSaleOffLabel || 'rabatt';

  // "2.727,00 kr" -> "2.727 kr" (the shop's money_without_trailing_zeros format)
  function tidy(text) {
    return text.replace(/,00(?=\s*kr)/, '').replace(/\s+/g, ' ').trim();
  }

  // "2.727,00 kr" -> 2727
  function amount(text) {
    var n = parseFloat(text.replace(/[^\d,]/g, '').replace(',', '.'));
    return isNaN(n) ? 0 : n;
  }

  function render(box) {
    var gsf = box.querySelector('.gsf-spd-price');
    if (!gsf) return;
    var sale = gsf.querySelector('.gsf-spd-sale-price');
    var regular = gsf.querySelector('.gsf-spd-regular-price');
    if (!sale || !regular) return;
    var s = amount(sale.textContent);
    var r = amount(regular.textContent);
    if (!(s > 0 && r > s)) return;

    var pct = Math.round((1 - s / r) * 100);
    // Not class "price": Simprosys hides every .price inside the price block (it means to hide the
    // theme's own price), and on the live theme it ran after us and hid this one too (07.10).
    var html =
      '<div class="kg-gsf-sale">' + tidy(sale.textContent) + '</div>' +
      '<div class="info"><div class="old">' + tidy(regular.textContent) + '</div>' +
      '<div class="save">' + pct + '% ' + label + '</div></div>';

    var own = box.querySelector('.kg-gsf-price');
    if (!own) {
      own = document.createElement('div');
      own.className = 'kg-gsf-price';
      own.style.display = 'contents';
      gsf.parentNode.insertBefore(own, gsf.nextSibling);
    }
    if (own.getAttribute('data-html') !== html) {
      own.innerHTML = html;
      own.setAttribute('data-html', html);
    }
    if (gsf.style.display !== 'none') gsf.style.display = 'none';
  }

  var queued = false;
  function scan() {
    queued = false;
    var boxes = document.querySelectorAll('[data-product-price]');
    for (var i = 0; i < boxes.length; i++) render(boxes[i]);
  }
  function queue() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(scan);
  }

  // Simprosys inserts its block after page load and rewrites it on variant change.
  new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      var t = records[i].target;
      if (t.closest && t.closest('.kg-gsf-price')) continue;
      queue();
      return;
    }
  }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });

  queue();
})();
